import InfoTooltip from '@/components/common/tooltip/InfoTooltip';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import React from 'react'

type Props = {
  title:string,
}

const ToolTip = (props: Props) => {
  const { title } = props;

  return (
    <InfoTooltip title={title} icon={
      <InfoOutlined/>
    }
    
    ></InfoTooltip>
  )
}

export default ToolTip;





